import React from 'react';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ActionBarIcon.scss';
const ActionBarIcon = ({ icon: Icon, iconRef, isActive, children })=>{
    const iconProps = {
        className: classnames(isActive && s['active']),
        customSizable: false,
        disableDefaultColors: true,
        containerRef: iconRef,
        iconSize: IconSize.MEDIUM
    };
    if (children) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children(iconProps));
    }
    if (Icon) {
        return /*#__PURE__*/ React.createElement(Icon, iconProps);
    }
    return null;
};
ActionBarIcon.displayName = 'ActionBarIcon';
export default ActionBarIcon;
